export function DartIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.69 7.178l2.104 3.158a3 3 0 010 3.328L5.69 16.822 18.012 12 5.689 7.178zM2.262 18.356l3.867-5.801a1 1 0 000-1.11L2.263 5.644C1.72 4.83 2.548 3.8 3.459 4.158l17.661 6.91c.848.332.848 1.532 0 1.863L3.46 19.842c-.912.357-1.74-.672-1.197-1.486z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
